import React from 'react';
import AppButton from '@/components/atoms/AppButton';
import '../../styles/authorization.scss';

export interface ForbiddenPageProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  isRetrying?: boolean;
}

/** HITOWA-themed authorization failure surface. */
export const ForbiddenPage: React.FC<ForbiddenPageProps> = ({
  title = 'アクセス権限がありません',
  message = 'この操作を実行する権限がありません。管理者にお問い合わせください。',
  onRetry,
  isRetrying = false,
}) => (
  <div
    role="alert"
    className="flex min-h-[60vh] items-center justify-center px-6 py-12"
    data-testid="hitowa-forbidden-page"
  >
    <section className="hitowa-authz-card w-full max-w-[520px] border bg-white px-8 py-10 text-center">
      <div
        className="hitowa-authz-code mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full text-xl font-bold"
        aria-hidden
      >
        403
      </div>
      <p className="hitowa-authz-muted mb-2 text-xs font-semibold tracking-[0.18em]">
        PERMISSION REQUIRED
      </p>
      <h1 className="hitowa-authz-title mb-3 text-xl font-bold">
        {title}
      </h1>
      <p className="hitowa-authz-muted m-0 text-sm leading-7">
        {message}
      </p>
      {onRetry && (
        <div className="mt-7">
          <AppButton type="primary" onClick={onRetry} loading={isRetrying}>
            権限情報を再読み込み
          </AppButton>
        </div>
      )}
    </section>
  </div>
);

export const PermissionLoadingPage: React.FC = () => (
  <div
    className="flex min-h-[60vh] items-center justify-center px-6 py-12"
    aria-busy="true"
    aria-live="polite"
    data-testid="hitowa-permission-loading"
  >
    <div className="text-center">
      <div className="hitowa-authz-spinner mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-t-transparent" />
      <p className="hitowa-authz-muted m-0 text-sm">
        権限情報を確認しています…
      </p>
    </div>
  </div>
);

export default ForbiddenPage;
